import { render } from "./Loan_Guarantors.vue?vue&type=template&id=152532fa"
import script from "./Loan_Guarantors.vue?vue&type=script&lang=js"
export * from "./Loan_Guarantors.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__